import { useRef } from "react";

export type SaveHandle = {
  save: () => Promise<void>;
  isDirty: () => boolean;
};

export const useSaveManager = <T extends string>() => {
  const refs = useRef<Record<T, SaveHandle | null>>({} as Record<T, SaveHandle | null>);

  const register = (key: T, ref: SaveHandle | null) => {
    refs.current[key] = ref;
  };

  const hasUnsavedChanges = (): boolean => {
    const entries = Object.entries(refs.current);
    const dirtyTabs = entries
      .filter((entry): entry is [string, SaveHandle] => {
        const [_, r] = entry;
        return r !== null && r !== undefined;
      })
      .filter(([_, r]) => r.isDirty())
      .map(([key]) => key);

    return dirtyTabs.length > 0;
  };

  const saveAll = async (): Promise<void> => {
    const handles = Object.values(refs.current).filter(
      (r): r is SaveHandle => r !== null && r !== undefined
    );
    for (const h of handles) {
      if (h.isDirty()) await h.save();
    }
  };

  return {
    register,
    hasUnsavedChanges,
    saveAll,
  };
};
